module.exports = __webpack_public_path__ + "static/media/falcon.69dbf6a5.png";